'use client';

import React, { useState } from 'react';

import { HStack, VStack, Box, Input } from '@chakra-ui/react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';

import { CustomDateInputProps, DateFilterProps } from '@modules/common/types';

const CustomDateInput = ({
    value,
    placeholder,
    onChange,
    min,
    max,
    width,
    disabled = false,
}: CustomDateInputProps) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <Box position="relative" width={width || '100%'}>
            {!value && !isFocused && (
                <Box
                    position="absolute"
                    color="gray.500"
                    fontSize={13}
                    top="50%"
                    left="10px"
                    transform="translateY(-50%)"
                    pointerEvents="none"
                    zIndex={1}
                >
                    {placeholder}
                </Box>
            )}

            <Input
                type="date"
                value={value}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                min={min}
                max={max}
                disabled={disabled}
                fontSize={13}
                padding={2}
                width="100%"
                css={css`
                    color: ${value ? 'black' : 'transparent'};

                    &::-webkit-calendar-picker-indicator {
                        position: absolute;
                        right: 8px;
                        cursor: pointer;
                    }
                `}
            />
        </Box>
    );
};

const DateFilter = ({
    fromLabel = 'dd/mm/yyyy',
    toLabel = 'dd/mm/yyyy',
    from,
    to,
    minFrom,
    maxFrom,
    setFrom,
    setTo,
    width = 0,
}: DateFilterProps) => (
    <HStack justify="space-between" width="100%" gap={2}>
        <VStack align="flex-start" width="100%">
            <CustomDateInput
                width={width}
                value={from}
                placeholder={fromLabel}
                min={minFrom}
                max={maxFrom}
                onChange={(e: { target: { value: React.SetStateAction<string> } }) =>
                    setFrom(e.target.value)
                }
            />
        </VStack>
        <VStack align="flex-start" width="100%">
            <CustomDateInput
                width={width}
                value={to}
                placeholder={toLabel}
                disabled={from === ''}
                min={from ? dayjs(from).add(1, 'day').format('YYYY-MM-DD') : ''}
                onChange={(e: { target: { value: React.SetStateAction<string> } }) =>
                    setTo(e.target.value)
                }
            />
        </VStack>
    </HStack>
);

export default DateFilter;
